/**
 * 勾选
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';

import { FormType, FormErrorType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemCheck extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      checkValue: [], // FormType.CHECK
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  setValue = (dataSource) => {
    // 强制赋值
    const { list, key, formType, extend, onValSetFinished } = dataSource;
    const checkValue = [];

    if (list && list.length !== 0) {
      list.forEach((item) => {
        checkValue.push(item.value);
      });
      this.setState({ checkValue });
      onValSetFinished && onValSetFinished(key, formType, extend);
    }
  };

  /**
   * 多选值变化监听
   * @param e
   * @param index
   */
  onCheckChange = (e, index) => {
    const { checkValue } = this.state;
    const { key, onChange, errorData, formType, list, extend } =
      this.props.dataSource;
    checkValue[index] = e.target.checked;
    const newList = [];
    list.forEach((item, i) => {
      newList.push({
        value: checkValue[i],
        label: item.label,
      });
    });

    let allow = true;
    for (let i = 0; i < errorData.length; i++) {
      const item = errorData[i];
      if (item.type === FormErrorType.NULL) {
        allow = checkValue.includes(true);
        break;
      }
    }

    this.setState({ checkValue });
    onChange && onChange(key, formType, newList, allow, extend);
  };

  /**
   * 渲染多选类型
   * @returns {*}
   */
  renderFormLineCheck() {
    const { errorMsg, checkValue } = this.state;
    const { key, list, inputAttr, newLine, bottomArea } = this.props.dataSource;
    return (
      <div className="form-input-box">
        <div className="form-radio">
          {list.map((item, index) => {
            return (
              <label
                key={`${key}formRadio${index}`}
                htmlFor={`${key}formRadio${index}`}
                className={`form-label-radio${newLine ? ' block' : ''}`}
              >
                <input
                  type="checkbox"
                  className="check"
                  {...inputAttr}
                  id={`${key}formRadio${index}`}
                  checked={checkValue[index]}
                  onChange={(e) => {
                    this.onCheckChange(e, index);
                  }}
                />
                <span>{item.label}</span>
              </label>
            );
          })}
        </div>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineCheck()}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemCheck.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.CHECK,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
